import Vue from 'vue'
import Router from 'vue-router'
import Axios from '@/assets/js/axios.js'
import store from '@/store'
import MQTTWrapper from '@/assets/js/mqttHandler'
import { login as loginUrl } from '@/assets/js/url.js'
import cockpit from '@/pages/index/cockpit.vue';
import index from '@/pages/index/index.vue';
import track from'@/pages/index/info-track.vue';
import newsinfo from'@/pages/index/news-info.vue';
import newsdetail from'@/pages/index/news-detail.vue';
import login from '@/pages/login.vue';
import threeDimensional from "@/pages/three-dimensional/three-dimensional.vue"
Vue.use(Router)

const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'indexPage',
      component: index
    },
    {
      path: '/index',
      name: 'indexPage',
      component: index
    },
    {
       path: '/cockpit',
       name: 'cockpit',
       component: cockpit
    },
    {
      path: '/track',
      name: 'info-track',
      component: track
    },
    {
     path: '/newsinfo',
     name: 'news-info',
     component: newsinfo
    },
    {
     path: '/newsdetail',
     name: 'news-detail',
     component: newsdetail
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/three-dimensional',
      name: 'three-dimensional',
      component: threeDimensional
    }
  ]
})

function getRedirectRoute(to) {
  let query = Object.assign({}, to.query)
  delete query.user_phone
  delete query.user_token
  return {
    path: to.path,
    query: query,
    hash: to.hash,
  }
}

function initMqtt() {
  return Axios({
    type: 'get',
    url: '/mcbw/file/template_static',
    obj: {
      fileKey: 'mqtt_url_ws'
    },
  }).then((res) => {
    if (!res || !res.data || !res.data.success || !res.data.data) {
      throw new Error('mqtt_url_ws empty')
    }
    window.localStorage.setItem('mqttapi', res.data.data)
    store.commit('setmqttapi', res.data.data)
    Vue.prototype.$mqtt = new MQTTWrapper()
  })
}

function platformLogin(to, next) {
  let loginName = to.query.user_phone
  let userToken = to.query.user_token

  if (!loginName || !userToken) {
    next({ name: 'login' })
    return
  }

  let passWord = userToken.substring(0, 64)

  window.localStorage.removeItem('loginData')
  window.localStorage.removeItem('hashValue')
  window.localStorage.setItem('lhLoginName', loginName)
  window.localStorage.setItem('lhPwdHash', passWord)

  Axios({
    type: 'post',
    url: loginUrl,
    obj: {
      user: loginName,
      password: passWord
    }
  }).then((res) => {
    if (res.data && res.data.code == 200) {
      window.localStorage.setItem('loginData', JSON.stringify(res.data.data.depInfo))
      window.localStorage.setItem('hashValue', passWord)
      window.localStorage.setItem('setAzindex', 'true')
      window.localStorage.removeItem('lhLoginName')
      window.localStorage.removeItem('lhPwdHash')

      initMqtt()
        .then(() => {
          next({ name: 'indexPage' })
        })
        .catch(() => {
          next({ name: 'login' })
        })
    } else {
      window.localStorage.removeItem('loginData')
      next({ name: 'login' })
    }
  }).catch(() => {
    window.localStorage.removeItem('loginData')
    next({ name: 'login' })
  })
}

router.beforeEach((to, from, next)=>{
  if(to.fullPath != '/login'){
    if(to.matched.length === 0){ //如果找不到页面，返回登录页面
      router.push({name:'login'});
    }else{
      if (to.fullPath.indexOf('user_phone') > -1 && to.fullPath.indexOf('user_token') > -1) {
        platformLogin(to, next)
      } else if (window.localStorage.getItem('loginData')) {
        next()
      } else {
        window.localStorage.removeItem('loginData')
        next({ name: 'login' })
      }
    }
  }else{
    next();
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js